<template>
  <v-card
    class="mt-2 flex-grow-1 d-flex flex-column"
    variant="outlined"
    color="grey lighten-5"
    :height="cardHeight"
  >
    <v-card-text class="pa-0 flex-grow-1" height="100%">
      <div :id="dynamicId" style="height: 100%; width: 100%"></div>
      <!-- Map creation dialog -->
      <v-dialog v-model="dialogMap" max-width="600">
        <template v-slot:activator="{ props: activatorProps }">
          <v-spacer></v-spacer>
          <v-sheet
            id="dialogTriggers"
            class="d-flex align-end flex-column pa-2"
            height="100%"
            color="transparent"
          >
            <v-btn
              :disabled="loading"
              icon
              v-bind="activatorProps"
              color="secondary"
              class="mb-4"
              size="x-small"
              ><v-tooltip activator="parent" location="left"
                ><span>{{ $t("strings.select-location") }}</span></v-tooltip
              ><v-icon size="large">mdi-target</v-icon>
            </v-btn>

            <v-btn
              :disabled="loading"
              color="primary"
              base-color="white"
              @click="resetMap()"
              icon
              size="x-small"
              class="mb-4"
              ><v-tooltip activator="parent" location="left"
                ><span>{{ $t("strings.reset-location") }}</span></v-tooltip
              ><v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-sheet>
        </template>
        <v-card>
          <v-toolbar color="secondary">
            <v-toolbar-title class="text-white">
              {{ $t("strings.select-location") }}
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn color="white" icon @click="dialogMap = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <CreationMap
            @updateGeolocation="updateGeolocation"
            :parentGeolocation="geolocation"
          ></CreationMap>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              variant="text"
              @click="dialogMap = false"
              >{{ $t("labels.cancel") }}</v-btn
            >
            <v-btn
              color="secondary darken-1"
              variant="text"
              @click="closeLocationDialog"
              >{{ $t("labels.save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- END Map creation dialog -->
    </v-card-text>
  </v-card>
</template>

<script>
import CreationMap from "./CreationMap.vue";
import mapMethods from "../mixins/mapMethods";
import utils from "../mixins/utils";

export default {
  name: "CreationMapContainer",
  props: [
    "parentGeolocation",
    "parentDynamicId",
    "parentLoading",
    "containerHeight",
  ],
  components: {
    CreationMap,
  },
  mixins: [mapMethods, utils],
  emits: ["updateGeolocation"],
  data() {
    return {
      dialogMap: false,
      geolocation: {
        latitude: "",
        longitude: "",
      },
      dynamicId: "map-container",
      loading: true,
      map: null,
      marker: null,
      markerLayer: null,
    };
  },
  mounted() {
    window.addEventListener("resize", this.updateContainerHeight);
    this.$nextTick(() => {
      this.geolocation = JSON.parse(JSON.stringify(this.parentGeolocation));
      this.loading = this.parentLoading;
      this.initMap();
    });
  },
  methods: {
    updateGeolocation(value) {
      if (
        this.geolocation.latitude !== value.latitude ||
        this.geolocation.longitude !== value.longitude
      ) {
        this.geolocation = value;
        this.$emit("updateGeolocation", value);
      }
    },
    resetMap() {
      this.$emit("updateGeolocation", { latitude: "", longitude: "" });
      this.markerLayer.clearLayers();
      this.map.setView([51.505, -0.09], 3);
    },
    //actions happening when closing the localization dialog
    closeLocationDialog() {
      const coordinates = this.geolocation;
      this.dialogMap = false; //close the dialog
      this.setLatLng(coordinates);
      this.setMarker(coordinates);
    },
  },
  watch: {
    dialogMap() {
      this.$nextTick(() => {
        this.map.invalidateSize(); // Ensure the map is correctly sized when dialog opens
      });
    },
    parentLoading(value) {
      this.loading = value;
    },
    mapHeight() {
      this.$nextTick(() => {
        this.map?.invalidateSize();
      });
    },
    parentGeolocation: {
      handler(newVal) {
        this.geolocation = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    cardHeight() {
      return `calc(${parseFloat(this.containerHeight) / 4}px)`;
    },
    mapHeight() {
      return `${parseFloat(this.containerHeight) / 4}px`;
    },
  },
};
</script>

<style>
#dialogTriggers {
  height: 100%;
  position: absolute;
  z-index: 1000;
  top: 0;
  right: 0;
}
</style>
